/*!
 * Created by netlogix GmbH & Co. KG.
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Reminder } from '@shared/models';

export interface RemindersState {
  myReminders: Reminder[];
  suspendedReminderIds: string[];
  reminderTimerIds: number[];
}

export const initialState: RemindersState = {
  myReminders: [],
  suspendedReminderIds: [],
  reminderTimerIds: []
};
